import styles from './PaymentsToggle.module.scss';

import cx from 'classnames';
import { PaymentsComparisonLink } from 'components/PaymentsComparisonLink/PaymentsComparisonLink';
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePaymentsToggle } from './usePaymentsToggle/usePaymentsToggle';
import { Installments } from '../types';
import { useCheckout } from 'components/Checkout/CheckoutProvider';
import { SproutButton } from 'components/Button/SproutButton';
import { LinkVariant } from 'api/contentful/contentTypes.cloverdotcom';
import { PAYMENTS_TOGGLE_TEST_ID } from './PaymentsToggle.const';

interface IPaymentsToggleProps {
  className?: string;
}

export const PaymentsToggle: FC<IPaymentsToggleProps> = ({ className }) => {
  const { t } = useTranslation();
  const { isPayMonthly, setIsPayMonthly } = usePaymentsToggle();
  const { setSelectedPurchaseType } = useCheckout();

  const handlePayButton = (payMonthly: boolean) => {
    setIsPayMonthly(payMonthly);
  };

  const handlePayInFullButton = () => {
    handlePayButton(false);
    setSelectedPurchaseType(Installments.P);
  };

  const handlePayMonthlyButton = () => {
    handlePayButton(true);
    setSelectedPurchaseType(Installments.SL36);
  };

  useEffect(() => {
    if (isPayMonthly) setSelectedPurchaseType(Installments.SL36);
  }, [isPayMonthly]);

  return (
    <section className={cx(styles.orderSummaryToggleButton, styles.wrapperNoBorderRadius, className)}>
      <div className={styles.toggleButtonContainer}>
        <SproutButton
          variant={LinkVariant.SECONDARY}
          className={cx(styles.toggleButton, styles.subscriptionButton, {
            [styles.disabledToggleButton]: !isPayMonthly,
          })}
          onClick={handlePayMonthlyButton}
          size="small"
          data-testid={PAYMENTS_TOGGLE_TEST_ID.subscriptionButton}
        >
          {t('order-summary.subscription')}
        </SproutButton>
        <SproutButton
          variant={LinkVariant.SECONDARY}
          className={cx(styles.toggleButton, styles.purchaseButton, {
            [styles.disabledToggleButton]: isPayMonthly,
          })}
          onClick={handlePayInFullButton}
          size="small"
          data-testid={PAYMENTS_TOGGLE_TEST_ID.purchaseButton}
        >
          {t('order-summary.purchase')}
        </SproutButton>
      </div>
      <div className={styles.compareLink}>
        <PaymentsComparisonLink className={styles.compareLinkBodySmall} />
      </div>
    </section>
  );
};
